export default __webpack_public_path__ + "static/media/share.9ed795cd.svg";